import DontDisturbResource from '../resource/DontDisturbResource';

export interface DontDisturbFile {
  fileName: string;
  url: string;
  expiresAt: string;
}

export default class DontDisturbService {
  static fetchFiles = async (): Promise<DontDisturbFile[]> => {
    const response = await DontDisturbResource.fetchFiles();
    return response.data;
  };
}
